import { Breakpoint, useMediaQuery, useTheme } from '@mui/material';

export const useDeviceWidth = (key: Breakpoint | number) => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(key));
};
